// Keeps track of the latest non-beta firmware version for K4
// this will allow us to direct users with higher versions of firmware to the beta site
/* TODO: we should update this to use the firmware endpoint
 https://github.com/PaxLabs/pax-web/pull/1225#discussion_r758847115 */
export const LATEST_PRODUCTION_FIRMWARE_VERSION = "5.6.4";

export const EXPERIENCE_MODE_COMPATIBLE_FIRMWARE_VERSION = "5.16.0";
